import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, PinIcon } from './icons';

/**
 * EventInfoCards
 * -------------------------------------------------------
 * The three-card row right under the Banner: Event Details,
 * What We're Showcasing (or a "Why We're There" fallback when
 * there's nothing to showcase), and a Get in Touch CTA card.
 */

function InfoCard({ icon, title, children }) {
  return (
    <div className="rounded-2xl border border-[rgb(35,180,85)] shadow-[0_0_15px_rgba(0,0,0,0.06)] p-6 flex flex-col h-full bg-white">
      <div className="flex items-center gap-3 mb-4">
        <span
          className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
          style={{ backgroundColor: 'rgba(35, 180, 85, 0.12)' }}
        >
          {icon}
        </span>
        <p className="font-bold text-xl font-gilroy">{title}</p>
      </div>
      {children}
    </div>
  );
}

export default function EventInfoCards({ event }) {
  const {
    name,
    date,
    location,
    tag,
    boothNumber,
    about,
    showcase = [],
    isPast,
  } = event;

  return (
    <div className="containers-min mx-auto px-4 py-12">
      
      <div className="grid md:grid-cols-3 gap-6 items-stretch">
        <InfoCard icon={<PinIcon className="w-5 h-5" />} title="Event Details">
          <ul className="space-y-2 font-poppins text-black/80">
            <li><strong>Date:</strong> {date}</li>
            <li><strong>Location:</strong> {location}</li>
            {tag === 'Exhibitor' && boothNumber && (
              <li><strong>Booth:</strong> {boothNumber}</li>
            )}
            <li><strong>Type:</strong> {tag}</li>
          </ul>
        </InfoCard>

        {showcase.length > 0 ? (
          <InfoCard icon={<CheckCircleIcon className="w-5 h-5" />} title="What We Showcased">
            <ul className="space-y-3">
              {showcase.map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <CheckCircleIcon className="w-4 h-4 shrink-0 mt-1" />
                  <span className="font-poppins text-black/80">{item}</span>
                </li>
              ))}
            </ul>
          </InfoCard>
        ) : (
          <InfoCard icon={<CheckCircleIcon className="w-5 h-5" />} title="Why We're There">
            <p className="font-poppins text-black/80">
              {about ? about.slice(0, 140) + (about.length > 140 ? '…' : '') : 'Details coming soon.'}
            </p>
          </InfoCard>
        )}

        <div className="rounded-2xl border border-[rgb(35,180,85)] shadow-[0_0_15px_rgba(0,0,0,0.06)] p-8 h-full flex flex-col justify-start bg-[rgb(35,180,85)] bg-opacity-[0.04] ">
          <p className="font-bold text-xl font-gilroy mb-3 leading-tight">
            {isPast ? 'Want to talk about what you saw?' : `Want to meet us at ${name}?`}
          </p>
          <p className="font-poppins text-black/70 mb-2">
            Get in touch and we&apos;ll set up time to connect{isPast ? '' : ' at the event'}.
          </p>
          <Link to="/get-in-touch" className="inline-block mt-4">
            <div className="bg-[rgb(35,180,85)] bg-opacity-5 backdrop-blur-sm border border-[rgb(35,180,85)] border-opacity-30 rounded-xl px-6 py-4 text-center group hover:bg-opacity-10 hover:shadow-md transition-all duration-300">
              <span className="font-poppins font-semibold text-[rgb(35,180,85)] inline-block group-hover:translate-x-1 transition-transform">
                Get in Touch →
              </span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
